var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.60744 0 0 5.60744 0 12.5C0 19.3926 5.60744 25 12.5 25C19.3926 25 25 19.3926 25 12.5C25 5.60744 19.3926 0 12.5 0ZM12.5 23.5955C6.38192 23.5955 1.40449 18.6181 1.40449 12.5C1.40449 6.38192 6.38192 1.40449 12.5 1.40449C18.6181 1.40449 23.5955 6.38192 23.5955 12.5C23.5955 18.6181 18.6181 23.5955 12.5 23.5955ZM19.382 11.7978H13.2022V3.74498C13.2022 3.35702 12.888 3.04274 12.5 3.04274C12.112 3.04274 11.7978 3.35702 11.7978 3.74498V12.5C11.7978 12.888 12.112 13.2022 12.5 13.2022H19.382C19.77 13.2022 20.0843 12.888 20.0843 12.5C20.0843 12.112 19.77 11.7978 19.382 11.7978Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextday);
export default __webpack_public_path__ + "static/media/nextday.27f8825a049a45f123935a7c2f627bad.svg";
export { ForwardRef as ReactComponent };